import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { 
  faCheckCircle 
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TabService } from 'src/app/core/services/tab.service';
import { Subscription } from 'rxjs';
import { Router, RoutesRecognized } from '@angular/router';


@Component({
  selector: 'progress-tab',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './progress-tab.component.html',
  styleUrls: ['./progress-tab.component.scss']
})
export class ProgressTabComponent implements OnInit, OnDestroy {
  
  @Input() countTab: number = 0;

  private _steps: number[] = [];
  private _currentStep: number = 0;

  // # Subscription
  private stepsSubscription!: Subscription;
  private currentSubscription!: Subscription;
  // end range

  // icons
  faCheckCircle = faCheckCircle;

  // Getter
  get steps(): number[] {
    return this._steps;
  }

  get currentStep(): number {
    return this._currentStep;
  }

  // Setter
  set steps(value: number[]) {
    this._steps = value;
  }

  set currentStep(value: number) {
    this._currentStep = value;
  }

  ofertaBase!:any;

  //boolen
  rutaCurrent!:boolean;

  constructor(private tabService:TabService, private router: Router) { }

  ngOnInit(): void {

    this.stepsSubscription = this.tabService.stepsSubject.subscribe({
      next: (steps) => {
        this.steps =  steps;
      }
    });

    this.currentSubscription = this.tabService.currentStepSubject.subscribe({
      next: (current) => {
        this.currentStep = current;
      }
    });

    this.tabService.setStepsConut(this.countTab);

  }

  ngOnDestroy(): void {
    if (this.stepsSubscription) {
      this.stepsSubscription.unsubscribe();
    }
    if (this.currentSubscription) {
      this.currentSubscription.unsubscribe();
    }
  }

}
